const Fields = {
    APV: {
        label: 'APV',
        type: '!struct',
        subfields: {
            facture: {
                label: 'N° facture',
                type: 'text',
                operators: [
                    'equal',
                    'not_equal',
                    'is_null',
                ],
            },
            name: {
                label: 'Nom affaire',
                type: 'text',
            },
            date: {
                label: 'Date de facture APV',
                type: 'date',
            },
            comments: {
                label: 'Commentaires',
                type: 'text',
                operators: [
                    'contains',
                ],
            },
            amount: {
                label: 'Montant facture',
                type: 'number',
            },
            code: {
                label: 'Immatriculation',
                type: 'text',
            },
            km: {
                label: 'Kilométrage',
                type: 'number',
            },
        }
    },
    Area: {
        label: 'Secteur Affaire',
        type: '!struct',
        subfields: {
            dealership: {
                label: 'Concession', 
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    "HORS SECTEUR": "HORS SECTEUR",
                    ARLES: 'ARLES',
                    BRIGNOLES: 'BRIGNOLES',
                    CAVAILLON: 'CAVAILLON',
                    DRAGUIGNAN: 'DRAGUIGNAN',
                    FREJUS: 'FREJUS',
                    GAP: 'GAP',
                    MANOSQUE: 'MANOSQUE'
                },
            },
        }
    },
    Car: {
        label: 'Voiture',
        type: '!struct',
        subfields: {
            brand: {
                label: 'Marque', 
                type: 'text',
            },
            model: {
                label: 'Modèle', 
                type: 'text',
            },
            vin: {
                label: 'VIN', 
                type: 'text',
            },
            date_first_code: {
                label: 'Date de 1ère immatriculation', 
                type: 'date',
            },
            code: {
                label: 'Immatriculation', 
                type: 'text',
            },
            date_begin: {
                label: 'Date début relation MAEVA', 
                type: 'date',
            },
            date_end: {
                label: 'Date fin relation MAEVA', 
                type: 'date',
            },
            date_delivery: {
                label: 'Date de livraison véhicule', 
                type: 'date',
            },
            contract: {
                label: 'Contrat', 
                type: 'text',
            },
            finance: {
                label: 'Financement', 
                type: 'text',
            },
            insurance: {
                label: 'Assurance', 
                type: 'text',
            },
            km: {
                label: 'Kilométrage', 
                type: 'number',
            },
            description: {
                label: 'Description', 
                type: 'text',
            },
            icm: {
                label: 'Icm', 
                type: 'text',
            },
            version: {
                label: 'Version', 
                type: 'text',
            },
            vpvu: {
                label: 'VPVU', 
                type: 'text',
            },
            seller: {
                label: 'Vendeur', 
                type: 'text',
            },
            folder_number: {
                label: 'Numéro de dossier', 
                type: 'number',
            },
            use: {
                label: 'Usage du véhicule', 
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    Professionnel: 'Professionnel',
                    Personnel: 'Personnel',
                    Familial: 'Familial',
                    Mixte: 'Mixte'
                },
            },
            replacement_interested: {
                label: 'Véhicule de remplacement', 
                type: 'boolean',
            },
            replacement_same: {
                label: 'Remplacement identique', 
                type: 'boolean',
            },
            place_purchase: {
                label: 'Lieu d\'achat', 
                type: 'text',
            },
            main_user: {
                label: 'Utilisateur principal', 
                type: 'text',
            },
            payer: {
                label: 'Payeur/financeur', 
                type: 'text',
            },
            decision_maker: {
                label: 'Décisionnaire d\'achat', 
                type: 'text',
            },
            funding: {
                label: 'Mode de financement', 
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    Comptant: 'Comptant',
                    "Crédit classique": 'Crédit classique',
                    Location: 'Location'
                },
            },
            avg_km: {
                label: 'Kilométrage moyen annuel', 
                type: 'number',
            },
            duration: {
                label: 'Durée de la location', 
                type: 'number',
            },
            budget: {
                label: 'Budget annuel accordé', 
                type: 'number',
            },
            date_order: {
                label: 'Date commande DCSnet', 
                type: 'date',
            },
            shortname: {
                label: 'Concession commande', 
                type: 'text',
            },
            conseilor: {
                label: 'Vendeur commande', 
                type: 'text',
            },
            agent: {
                label: 'Agent', 
                type: 'text',
            },
            order_service: {
                label: 'Service commande', 
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    VN: 'VN',
                    VO: 'VO',
                },
            },
            date_start_diac: {
                label: 'Date d\'entrée en gestion DIAC', 
                type: 'date',
            },
            diac_contract_number: {
                label: 'Numéro de contrat DIAC', 
                type: 'text',
            },
            diac_financial_product: {
                label: 'Produit financier DIAC', 
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    CB: 'CB',
                    CC: 'CC',
                    DL: 'DL',
                    LL: 'LL',
                    LP: 'LP',
                    OV: 'OV',
                },
            },
            diac_market: {
                label: 'Marché DIAC', 
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    ENTREPRISES: 'ENTREPRISES',
                    LOUEURS: 'LOUEURS',
                    PARTICULIERS: 'PARTICULIERS',
                    PGR: 'PGR',
                    RESEAU: 'RESEAU',
                },
            },
            diac_commercial_offer: {
                label: 'Offre commerciale DIAC', 
                type: 'text',
            },
            diac_duration: {
                label: 'Durée DIAC', 
                type: 'number',
            },
            diac_insurance: {
                label: 'Prestations assurances DIAC', 
                type: 'text',
            },
            diac_insurance_number: {
                label: 'Nombre d\'assurances DIAC', 
                type: 'number',
            },
            diac_egvo_number: {
                label: 'Nb EGVO DIAC', 
                type: 'number',
            },
            diac_selling_price: {
                label: 'Prix de Vente DIAC', 
                type: 'number',
            },
            diac_ca: {
                label: 'CA DIAC', 
                type: 'number',
            },
            diac_er: {
                label: 'ER DIAC', 
                type: 'number',
            },
            diac_insurable: {
                label: 'Barême assurable DIAC', 
                type: 'boolean',
            },
            date_start_ctsce: {
                label: 'Date de début de contrat CtSce', 
                type: 'date',
            },
            contract_number_ctsce: {
                label: 'N° de contrat CtSce', 
                type: 'text',
            },
            scale_code_ctsce: {
                label: 'Code barème CtSce', 
                type: 'text',
            },
            maintenance_class_ctsce: {
                label: 'Classe entretien CtSce', 
                type: 'text',
            },
            product_family_ctsce: {
                label: 'Code famille produit CtSce', 
                type: 'text',
            },
            duration_ctsce: {
                label: 'Durée souscrite CtSce', 
                type: 'number',
            },
            km_ctsce: {
                label: 'Km souscrit CtSce', 
                type: 'number',
            },
            supplier_ctsce: {
                label: 'Nom fournisseur CtSce', 
                type: 'text',
            },
            market_type_ctse: {
                label: 'Type Marché CtSce', 
                type: 'text',
            },
            product_detail: {
                label: 'Produit détaillé', 
                type: 'text',
            },
            engraving: {
                label: 'Gravage', 
                type: 'text',
            },
            date_engraving: {
                label: 'Date gravage', 
                type: 'date',
            },
        }
    },
    Client: {
        label: 'Client',
        type: '!struct',
        subfields: {
            name: {
                label: 'Nom',
                type: 'text',
            },
            first_name: {
                label: 'Prénom',
                type: 'text',
            },
            company: {
                label: 'Société',
                type: 'text',
            },
            siret: {
                label: 'Siret',
                type: 'text',
            },
            address: {
                label: 'Adresse',
                type: 'text',
            },
            postal_code: {
                label: 'Code postal',
                type: 'text',
            },
            city: {
                label: 'Ville',
                type: 'text',
            },
            phone: {
                label: 'Téléphone fixe',
                type: 'text',
                operators: [
                    'equal',
                    'not_equal',
                    'is_not_null',
                ],
            },
            phone_mobile: {
                label: 'Téléphone mobile',
                type: 'text',
                operators: [
                    'equal',
                    'not_equal',
                    'is_not_null',
                ],
            },
            email: {
                label: 'Adresse email',
                type: 'text',
            },
            active: {
                label: 'Actif',
                type: 'boolean',
            },
            call_agree: {
                label: 'Accord de communication téléphone',
                type: 'boolean',
            },
            sms_agree: {
                label: 'Accord de communication sms',
                type: 'boolean',
            },
            mail_agree: {
                label: 'Accord de communication mail',
                type: 'boolean',
            },
            my_renault: {
                label: 'My renault',
                type: 'text',
            },
            my_dacia: {
                label: 'My dacia',
                type: 'text',
            },
            latitude: {
                label: 'Latitude',
                type: 'number',
            },
            longitude: {
                label: 'Longitude',
                type: 'number',
            },
            code: {
                label: 'Code',
                type: 'text',
            },
            ape: {
                label: 'APE',
                type: 'text',
            },
            activity: {
                label: 'Activité',
                type: 'text',
            },
            birthdate: {
                label: 'Date de naissance',
                type: 'date',
            },
            birth_address: {
                label: 'Lieu de naissance',
                type: 'text',
            },
            gender: {
                label: 'Sexe',
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    0: 'HOMME',
                    1: 'FEMME',
                    2: 'NEUTRE'
                },
            },
            family: {
                label: 'Situation familiale',
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    CELIBATAIRE: "Célibataire",
                    CONCUBINAGE: "Concubinage",
                    "MARIE(E)": "Marié(e)",
                    "PACSE(E)": "Pacsé(e)",
                    "DIVORCE(E) SEPARE(E)": "Divorcé/Séparé",
                    "VEUF(VE)": "Veuf(ve)",
                },
            },
            dead: {
                label: 'Décédé',
                type: 'boolean',
            },
            call_agree_date: {
                label: 'Date accord de communication téléphone',
                type: 'date',
            },
            sms_agree_date: {
                label: 'Date accord de communication sms',
                type: 'date',
            },
            mail_agree_date: {
                label: 'Date accord de communication mail',
                type: 'date',
            },
            real_estate: {
                label: 'Immobilier',
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    Propriétaire: 'Propriétaire',
                    Locataire: 'Locataire'
                },
            },
            ze_compatible: {
                label: 'Compatibilité ZE du client',
                type: 'boolean',
            },
            profession: {
                label: 'Profession',
                type: 'text',
            },
            social_networks: {
                label: 'Réseaux sociaux',
                type: 'text',
            },
            animals: {
                label: 'Animaux possédés',
                type: 'text',
            },
            sports: {
                label: 'Sports',
                type: 'text',
            },
            hobbies: {
                label: 'Loisirs / activités culturelles',
                type: 'text',
            },
            // household: {
            //     label: 'composition du foyer',
            //     type: 'number',
            // },
            children: {
                label: 'Année de naissance des enfants',
                type: 'text',
            },
            criterias: {
                label: 'Critères prioritaires dans le choix d\'un véhicule',
                type: 'text',
            },
            useful_equipements: {
                label: 'Equipements impératifs d\'un futur véhicule',
                type: 'text',
            },
            useless_equipements: {
                label: 'Equipements interdits ou inutiles',
                type: 'text',
            },
            renault_experience: {
                label: 'Expérience Renault',
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    Fidèle: 'Fidèle',
                    Perdu: 'Perdu',
                    Conquête: 'Conquête',
                    Partiel: 'Partiel'
                },
            },
            avg_km: {
                label: 'Kilométrage moyen annuel',
                type: 'number',
            },
            renewal: {
                label: 'Périodicité moyenne de renouvellement',
                type: 'number',
            },
            maintenance_renault: {
                label: 'Lieu d\'entretien du véhicule',
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    0: 'Autre garage',
                    1: 'Renault'
                },
            },
            renault_feedback: {
                label: 'Avis',
                type: 'text',
            },
            garage: {
                label: 'Garage',
                type: 'text',
            },
            garage_comment: {
                label: 'Commentaire sur le garage',
                type: 'text',
                operators: [
                    'contains',
                ],
            },
            apv_expectations: {
                label: 'Attentes en matière de SAV',
                type: 'text',
            },
            apv_funding: {
                label: 'Habitudes de financement APV',
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    Comptant : 'Comptant',
                    "Plusieurs fois": 'Plusieurs fois'
                },
            },
        }
    },
    // Area: {
    //     label: 'Secteur affaire',
    //     type: '!struct',
    //     subfields: {
    //         dealership: {
    //             label: 'Concession',
    //             type: 'text',
    //         },
    //     }
    // },
    Edit: {
        label: 'Modifications',
        type: '!struct',
        subfields: {
            email: {
                label: 'Email',
                type: 'text',
            },
            date: {
                label: 'Date de modification',
                type: 'date',
            },
            reason: {
                label: 'Raison',
                type: 'text',
            },
        }
    },
    Opinion: {
        label: 'Avis client',
        type: '!struct',
        subfields: {
            source: {
                label: 'Source',
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    GarageScore: 'GarageScore',
                    Google: 'Google',
                    Facebook: 'Facebook',
                    VOC: 'VOC',
                },
            },
            dealership: {
                label: 'Concession',
                type: 'text',
            },
            service: {
                label: 'Service',
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    VN: 'VN',
                    VO: 'VO',
                    AT: 'AT',
                },
            },
            note: {
                label: 'Note',
                type: 'number',
            },
            date: {
                label: 'Date avis',
                type: 'date',
            },
            comment: {
                label: 'Commentaire',
                type: 'text',
                operators: [
                    'contains',
                ],
            },
        }
    },
    Relation: {
        label: 'Relation',
        type: '!struct',
        subfields: {
            nature: {
                label: 'Nature',
                type: 'text',
            },
            date: {
                label: 'Date création relation client',
                type: 'date',
            },
            conseilor: {
                label: 'Conseiller',
                type: 'text',
            },
            canal: {
                label: 'Canal',
                type: 'select',
                operators: [
                    'select_equals',
                ],
                listValues: {
                    "CAMPAGNE": 'CAMPAGNE',
                    "DIAC": 'DIAC',
                    "FACEBOOK MARKET": 'FACEBOOK',
                    "INTERNET": 'INTERNET',
                    "La Centrale": 'LA CENTRALE',
                    "La Centrale Vitrine": 'LA CENTRALE VITRINE',
                    "leboncoin.fr": 'LeBonCoin',
                    "Local": 'LOCAL',
                    "Paru Vendu": 'PARU VENDU',
                    "SITE WEB": 'SITE WEB',
                    "Vivacar": 'VIVACAR',
                },
            },
            type: {
                label: 'Type',
                type: 'text',
            },
            interest: {
                label: 'Type d\'intérêt',
                type: 'text',
            },
            under_interest: {
                label: 'Sous-type d\'intérêt',
                type: 'text',
            },
            progress: {
                label: 'Avancement',
                type: 'text',
            },
            shortname: {
                label: 'Nom affaire',
                type: 'text',
            },
            owner: {
                label: 'Propriétaire',
                type: 'text',
            },
            comment: {
                label: 'Commentaire',
                type: 'text',
                operators: [
                    'contains',
                ]
            },
        }
    },
};

export default Fields;


// WEBPACK FOOTER //
// ./src/Components/QueryBuilder/Fields.js